import { FC } from 'react';

import { QrCodeImportModalContent } from './QrCodeImportModalContent/QrCodeImportModalContent';

interface QrCodeImportProps {
  isOpen: boolean;
  isSubmitLoading: boolean;
  onUploadFinishClick: ({ sessionId }: { sessionId: string }) => void;
  id?: string;
  sellerId: string;
}

export const QrCodeImportModal: FC<QrCodeImportProps> = ({
  isOpen,
  onUploadFinishClick,
  isSubmitLoading,
  id,
  sellerId,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <QrCodeImportModalContent
      id={id}
      sellerId={sellerId}
      onUploadFinishClick={onUploadFinishClick}
      isSubmitLoading={isSubmitLoading}
    />
  );
};
